import { render, staticRenderFns } from "./ElectionProbability.vue?vue&type=template&id=fa76db56&scoped=true"
import script from "./ElectionProbability.vue?vue&type=script&lang=js"
export * from "./ElectionProbability.vue?vue&type=script&lang=js"
import style0 from "./ElectionProbability.vue?vue&type=style&index=0&id=fa76db56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76db56",
  null
  
)

export default component.exports